import { render, staticRenderFns } from "./InstanceSliceProfile.vue?vue&type=template&id=1712e81c&"
import script from "./InstanceSliceProfile.vue?vue&type=script&lang=js&"
export * from "./InstanceSliceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports